module.exports = __webpack_public_path__ + "img/40_38_037_560.5f2fe59d.jpg";